import { combineReducers } from 'redux';

import authReducer from './auth';
import foodnaReducer from './foodna';

export default combineReducers({
    auth: authReducer,
    foodna: foodnaReducer
});



// WEBPACK FOOTER //
// ./src/reducers/index.js